import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MPopover from '@material-ui/core/Popover';
import cn from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  popover: {
    padding: '1rem',
    maxWidth: 400,
    wordBreak: 'break-word',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
});

const Popover = ({ children, anchorEl, handleClose, id, className }) => {
  const classes = useStyles();

  return (
    <MPopover
      id={id}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      classes={{
        paper: cn(classes.popover, className),
      }}
    >
      {children}
    </MPopover>
  );
};

Popover.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func,
  className: PropTypes.string,
};

Popover.defaultProps = {
  className: '',
};

export default memo(Popover);
